import config from '@/config/config';
import { ApolloClient, ApolloLink, from, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

export enum ApolloClientName {
  AccountsBff = 'accounts-bff',
  ParentAppBff = 'parent-app-bff',
}

const accountsBffHttpLink = new HttpLink({
  uri: config.REACT_APP_ACCOUNTS_BFF_URI,
  credentials: 'include',
});

const parentAppBffHttpLink = new HttpLink({
  uri: config.REACT_APP_PARENT_APP_BFF,
  credentials: 'include',
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log(graphQLErrors);
  }

  if (networkError) {
    // handle network error
    console.log(networkError);
  }
});
const accountsBffLink = from([errorLink, accountsBffHttpLink]);
const parentAppBffLink = from([errorLink, parentAppBffHttpLink]);

const apolloClient = new ApolloClient({
  link: ApolloLink.split(
    // Routes the query to the proper client
    operation => operation.getContext().clientName === ApolloClientName.AccountsBff,
    accountsBffLink,
    parentAppBffLink
  ),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          getAllFlyers: {
            keyArgs: ['input', ['filters', 'sort']],
          },
        },
      },
      Flyer: {
        keyFields: ['flyerId'],
      },
    },
  }),
  defaultOptions: {
    mutate: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});

export default apolloClient;
